import { ReactNode, useEffect, useState } from "react"
import { ChevronDown, ChevronRight } from "react-bootstrap-icons";

export const Acordeon: React.FC<{ header: ReactNode, body: ReactNode, cerradoInicial?: true | undefined }> = ({ header, body, cerradoInicial }) => {

    const [abierto, setAbierto] = useState(true);

    useEffect(() => {
        if (cerradoInicial) {
            setAbierto(false)
        }
        // eslint-disable-next-line
    }, [])

    return <>
        <div style={{ position: "relative" }}>
            <span onClick={() => { setAbierto(!abierto) }} className="text-white" style={{ cursor: "pointer", position: "absolute", right: 8, top: 8 }}>{abierto ? <ChevronDown /> : <ChevronRight />}</span>
            {header}
        </div>
        <div className={abierto ? "" : "d-none"}>{body}</div>
    </>
}